import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ChangeEvent, FC, useState } from "react";

import styles from "./documentCountBox.module.scss";

type TDocumentCountBoxProps = {
    title: string,
    icon?: IconDefinition,
    hasCheckbox?: boolean,
    count: number,
    onClick: () => void
}

export const DocumentCountBox: FC<TDocumentCountBoxProps> = ({ count, icon, title, hasCheckbox, onClick }: TDocumentCountBoxProps) => {

    const [isChecked, setIsChecked] = useState(true);

    const onCheckboxChange = (changeEvent: ChangeEvent<HTMLInputElement>): void => {
        setIsChecked(changeEvent.target.checked);
    }

    return (
        <div onClick={onClick} className={styles.documentCountBox}>
            <div className={styles.countName}>
                {icon ? <FontAwesomeIcon className={styles.countNameIcon} icon={icon} /> : <></>}
                <span>{title}</span>
            </div>
            <div className={styles.countBody}>
                {hasCheckbox ?
                    <input className={styles.countCheckbox} type="checkbox" checked={isChecked} onChange={onCheckboxChange} />
                    : <></>
                }
                <div className={styles.countCounts}>
                    <span>{count}</span>
                    {hasCheckbox ? <span>({count})</span> : <></>}
                </div>
            </div>
        </div>
    );
}